import Vue from 'vue';

// When the request succeeds
const success = (response, context) => {
  toastr.success(context.$t("analytics.index.reviews_tab.alert_added_success"));
  context.closeModal('#add-alerts');
  return response.data;
};

// When the request fails
const failed = (error, context) => {
  context.closeModal('#add-alerts');
  context.showToasterError(error);
};

export default (context, alerts, id) => {
  return Vue.$http.post('/rentals/update-alerts/' + id, alerts)
    .then((response) => {
      if (response && response.status === 200) {
        success(response, context);
      } else {
        failed(response, context);
      }
    }).catch((error) => {
      failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/rental/updateAlerts.js